import { Resource } from "i18next";

import { LOCALES } from "../locales";
import { TResourceBundles } from "../resources";

/**
 * Flips namespace-first bundles into the locale-first shape i18next wants:
 * `{ common: { uk, en } }` → `{ uk: { common }, en: { common } }`.
 */
export const toI18nextResources = (bundles: TResourceBundles): Resource =>
  Object.fromEntries(
    LOCALES.map(locale => [
      locale,
      Object.fromEntries(
        Object.entries(bundles).map(([namespace, bundle]) => [
          namespace,
          bundle[locale],
        ]),
      ),
    ]),
  );
